<template>
  <div class="town-select">
    <select
      class="town-select-input"
      :value="activeTown"
      @change="handleChange"
    >
      <option :value="0">吴川市</option>
      <option v-for="t in towns" :key="t.id" :value="t.id">
        {{ t.name }} ({{ townCountMap[t.id] || 0 }})
      </option>
    </select>
    <i class="fa-solid fa-chevron-down town-select-icon"></i>
  </div>
</template>

<script>
export default {
  name: 'TownSelect',

  props: {
    towns: { type: Array, default: () => [] },
    activeTown: { type: Number, default: 0 },
    townCountMap: { type: Object, default: () => ({}) }
  },

  emits: ['update:activeTown', 'select-town', 'select-all'],

  methods: {
    handleChange(e) {
      const value = Number(e.target.value)
      this.$emit('update:activeTown', value)
      if (value === 0) {
        this.$emit('select-all')
      } else {
        const town = this.towns.find(t => t.id === value)
        if (town) {
          this.$emit('select-town', town)
        }
      }
    }
  }
}
</script>

<style scoped>
.town-select {
  position: relative;
  flex-shrink: 0;
  height: 40px;
  display: flex;
  align-items: center;
}

.town-select-input {
  appearance: none;
  -webkit-appearance: none;
  background: transparent;
  border: none;
  border-right: 1px solid #e5e7eb;
  border-radius: 0;
  height: 24px;
  padding: 0 24px 0 14px;
  font-size: 13px;
  font-weight: 600;
  color: #0167CC;
  cursor: pointer;
  outline: none;
  transition: color .2s;
  min-width: 60px;
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 24px;
}

.town-select-input:focus {
  color: #014d99;
}

.town-select-input:active {
  color: #014d99;
}

.town-select-icon {
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 9px;
  color: #0167CC;
  pointer-events: none;
}
</style>
